var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16699 0.0416718C3.67968 0.0416718 0.0419922 3.67936 0.0419922 8.16667C0.0419922 12.654 3.67968 16.2917 8.16699 16.2917C10.1857 16.2917 12.0324 15.5555 13.4534 14.3369L16.8917 17.7753C17.1358 18.0194 17.5315 18.0194 17.7756 17.7753C18.0197 17.5312 18.0197 17.1355 17.7756 16.8914L14.3373 13.4531C15.5558 12.0321 16.292 10.1854 16.292 8.16667C16.292 3.67936 12.6543 0.0416718 8.16699 0.0416718ZM1.29199 8.16667C1.29199 4.36971 4.37004 1.29167 8.16699 1.29167C11.964 1.29167 15.042 4.36971 15.042 8.16667C15.042 11.9636 11.964 15.0417 8.16699 15.0417C4.37004 15.0417 1.29199 11.9636 1.29199 8.16667Z",
    fill: "#22ABCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.e87397946bd323a07a668b012f2f9a13.svg";
export { ForwardRef as ReactComponent };